import _ from "lodash";

/**
 * Convert a string to upper case.
 *
 * Each word of string will be converted.
 *
 * @param {string} str String to be converted
 * @returns {string} Converted (upper-cased) string
 */
export const toTitleCase = str =>
  str.toLowerCase().replace(/(^| )(\w)/g, s => s.toUpperCase());

/**
 * String shortener.
 *
 * Limit string `str` length by cutting it (extra chars) from right side.
 *
 * String limit by default - 50 characters.
 *
 * You can also set a custom length value using `size` param.
 *
 * @param {string} str String to be converted (trimmed)
 * @param {number} size String length. If more - will be trimmed.
 * @returns string Converted string
 */
export const concatStr = (str, size = 50) => {
  if (String(str).length < size) return str;
  return `${str.slice(0, size)}...`;
};

/**
 * Check if URL is matched with current user's location.
 *
 * @param {string} url URL path to compare
 * @returns boolean
 */
export const isMatchURL = url => window.location.href.indexOf(url) > -1;

/**
 * Format number to currency format.
 *
 * @param {number} amount Number to be converted to currency
 * @returns number
 */
export const formatCurrency = amount => {
  if (!_.isNumber(amount)) return `$0.00`;

  const curr = Number(amount);
  const formatted = curr.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
  return `$${formatted}`;
};

/**
 * Removes file's extension from filename.
 *
 * @param {string} filename Filename with extension
 * @returns string Filename without extension
 */
export const cutFileExtension = filename => filename.replace(/\.[^/.]+$/, "");

/**
 * Removes all letters from passed string.
 *
 * @param {string} str String that may contain letters
 * @returns string String that contains just digits
 */
export const formatNumberString = str => String(str).replace(/\D/g, "");

export const truncateStr = (str, length = 50, omission = "") =>
  _.truncate(_.trim(str), { length, omission });



// WEBPACK FOOTER //
// ./src/helpers/StringHelper.js